/**
 * Path-based admin URL routing helpers (SPA-side).
 *
 * Mirrors `apps/admin-worker/src/lib/slug.ts::extractOrgSlugFromPath`.
 * Phase 0: copied here so the SPA can decide which router chunk to load
 * before any API call. Move to `packages/host/` once it stabilizes.
 *
 * URL convention (docs/archive/20260505-admin-url-path-based.md):
 *   /                          → PlatformAdmin / shared (router decides)
 *   /p/...                     → PlatformAdmin route
 *   /login                     → shared
 *   /o/{slug}/...              → Org-scoped route
 */

const SLUG_REGEX = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

/**
 *   /                       → null
 *   /p/dashboard            → null
 *   /login                  → null
 *   /o/kurume-u             → "kurume-u"
 *   /o/kurume-u/projects/.. → "kurume-u"
 */
export function extractOrgSlugFromPath(pathname: string): string | null {
  const m = /^\/o\/([^/]+)(?:\/|$)/.exec(pathname);
  if (!m) return null;
  const candidate = m[1]!;
  if (!SLUG_REGEX.test(candidate)) return null;
  return candidate;
}

/**
 * True when the path is a PlatformAdmin or shared (login, root) route, i.e.
 * NOT an Org-scoped `/o/{slug}/...` path.
 */
export function isPlatformPath(pathname: string): boolean {
  return extractOrgSlugFromPath(pathname) === null;
}
